import React from "react";
import loadImage from "blueimp-load-image";
import ReactSelect, { components } from "react-select";
import classnames from "classnames";
import moment from "moment";
import DateTimePicker from "../../../components/DateTimePicker";
import TimePicker from "../../../components/TimePicker";
import Firebase from "../../../firebasehelper";
import "./index.css";

const TaskOptions = [
  "Sweepstakes",
  "Vote Contest",
  "Photo Contest",
  "Video Contest",
  "Caption Contest",
  "Choose your favourite mix",
  "Choose your top 10",
  "Like to Win",
  "Comment to Win",
  "Share Photo to Win",
];

const MenuList = (props) => {
  const { options, setValue } = props;
  return (
    <components.MenuList {...props}>
      {options.map((option) => (
        <div
          className="competition-task-menu-item"
          onClick={() => {
            setValue(option);
          }}
        >
          {option.label}
        </div>
      ))}
    </components.MenuList>
  );
};

const SingleValue = ({ children, data, ...props }) => {
  return (
    <components.SingleValue {...props}>
      <div className="fcompetition-task-selected-value">{data.label}</div>
    </components.SingleValue>
  );
};

class AddCompetition extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      img_content: "",
      title: "",
      description: "",
      content: "",
      task: "",
      postNow: true,
      scheduledDate: moment(),
      runUntil: moment(),
      hot_topic_tags: [],
      hot_topic: null,
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedDate !== this.props.selectedDate) {
      this.setState({ postNow: true }, () => {
        this.setState({
          postNow: false,
          scheduledDate: this.props.selectedDate,
        });
      });
    }
    if (prevProps.brand_name !== this.props.brand_name) {
      const brand_name = this.props.brand_name;
      Firebase.getAllHotTopics(brand_name, (hot_topics) => {
        let hot_topic_tags = hot_topics.map((topic) => {
          let label = `${topic.starting_monday
            .toDate()
            .toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
            })} - ${topic.tag}`;
          let value = topic;
          return { label, value };
        });
        this.setState({ hot_topic_tags });
      });
    }
  }

  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  selectedFile = (e) => {
    let _this = this;
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function (data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          function (canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            _this.setState({ content: img_src });
            let img_content = "data:image/jpeg;base64," + img_src;
            _this.setState({ img_content });
          },
          {
            canvas: true,
            orientation: orientation,
          }
        );
      });
    }
  };

  isSaveDisabled = () => {
    const {
      title,
      description,
      content,
      img_content,
      task,
      postNow,
      hot_topic,
      scheduledDate,
      runUntil,
    } = this.state;
    let dateValidation = true;
    let current = moment(new Date());
    if (!postNow) {
      if (hot_topic) {
        if (hot_topic.value) {
          let monday = hot_topic.value.starting_monday;
          monday = monday.toDate();
          let nextMonday = new Date();
          nextMonday.setDate(monday.getDate() + 7);
          let end_monday = moment(nextMonday);
          if (
            !moment(scheduledDate).isBefore(end_monday) ||
            !moment(scheduledDate).isAfter(current)
          ) {
            dateValidation = false;
          }
        }
      } else {
        if (
          !moment(scheduledDate).isAfter(current) ||
          !moment(runUntil).isAfter(scheduledDate)
        ) {
          dateValidation = false;
        }
      }
    } else {
      if (!moment(runUntil).isAfter(current)) {
        dateValidation = false;
      }
    }
    return (
      !title ||
      !description ||
      !content ||
      !img_content ||
      !task ||
      !dateValidation
    );
  };

  post = () => {
    const { onAdd } = this.props;
    const {
      title,
      content,
      description,
      task,
      postNow,
      scheduledDate,
      runUntil,
      hot_topic,
    } = this.state;
    onAdd(
      title,
      content,
      description,
      task,
      this.props.selectedDate ? false : postNow,
      scheduledDate,
      runUntil,
      hot_topic ? hot_topic.value.id : hot_topic
    );
    this.setState({
      img_content: "",
      title: "",
      description: "",
      content: "",
      task: "",
      postNow: true,
      scheduledDate: moment(),
      runUntil: moment(),
    });
  };

  handlePostNowChanged = (value) => () => {
    this.setState({
      postNow: value,
    });
  };

  onChangeScheduledDate = (value) => {
    this.setState({
      scheduledDate: value,
    });
  };

  onChangeRunUntilDate = (value) => {
    this.setState({
      runUntil: value,
    });
  };

  openCompetitionImage = () => {
    const competitionImageElm = document.getElementById("competition_img");
    if (competitionImageElm) {
      competitionImageElm.click();
    }
  };
  onChangeTime = (obj) => {
    const { scheduledDate } = this.state;
    const { hh, mm, of } = obj;
    let hours = hh;
    let newMoment = moment(scheduledDate);
    if (of === "pm" && hh !== 12) hours = hh + 12;
    newMoment.set("hour", hours);
    newMoment.set("minute", mm);
    this.setState({ scheduledDate: newMoment });
  };
  render() {
    const {
      title,
      img_content,
      description,
      task,
      postNow,
      hot_topic_tags,
      hot_topic,
      scheduledDate,
      runUntil,
    } = this.state;
    const { selectedDate } = this.props;
    return (
      <div
        className="modal fade add-post-dialog"
        id="add_competition_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content add-competition-dialog-content">
            <div className="modal-header">
              <h5 className="modal-title">Add a new competition</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                ref={(button) => (this.dismissElement = button)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1 ">
              <div className="form-group row">
                <div className="col-12">
                  <ReactSelect
                    value={task ? { label: task, value: task } : null}
                    onChange={(e) => {
                      this.setState({ task: e.value });
                    }}
                    options={TaskOptions.map((obj) => ({
                      value: obj,
                      label: obj,
                    }))}
                    placeholder="Competition task"
                    isSearchable={false}
                    components={{ MenuList, SingleValue }}
                  ></ReactSelect>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-12">
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    placeholder="Competition title"
                    onChange={this.onChangeHandler}
                    value={title}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-12 competition-image-container">
                  <button
                    className="btn btn-hero-lg btn-hero-success competition-image-btn"
                    onClick={this.openCompetitionImage}
                  >
                    Choose Image
                  </button>
                  <input
                    type="file"
                    id="competition_img"
                    name="image"
                    className="form-control-file"
                    accept="image/*"
                    onChange={this.selectedFile}
                    style={{ display: "none" }}
                  />
                  {img_content && (
                    <div className="mt-3">
                      <img
                        src={img_content}
                        alt="post_img"
                        className="w-100"
                        style={{
                          maxHeight: "150px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="form-group row">
                <div className="col-12">
                  <textarea
                    className="form-control competition_content "
                    name="description"
                    value={description}
                    placeholder="Competition description and terms"
                    onChange={this.onChangeHandler}
                  ></textarea>
                </div>
              </div>

              {hot_topic_tags.length > 0 && (
                <div
                  className="form-group"
                  style={{ marginTop: 30, width: 500 }}
                >
                  <div className="col-12">
                    <ReactSelect
                      isSearchable={true}
                      value={hot_topic}
                      onChange={(e) => {
                        const { label, value } = e;
                        this.setState({ hot_topic: { label, value } });
                      }}
                      options={[
                        { label: "None", value: null },
                        ...hot_topic_tags,
                      ]}
                      placeholder="Select a hot topic tag"
                      styles={{
                        option: (provided, state) => ({
                          ...provided,
                          textAlign: "left",
                        }),
                      }}
                    ></ReactSelect>
                  </div>
                </div>
              )}
              <div className="competition-schedule-container">
                <p className="competition-schedule-title">
                  {!selectedDate && (
                    <React.Fragment>
                      <b>Post now</b> or{" "}
                    </React.Fragment>
                  )}
                  <b>Schedule</b>
                </p>
                {!selectedDate && (
                  <div className="competition-schdule-now-container">
                    <div
                      className={classnames("check-box", {
                        checked: postNow,
                      })}
                      onClick={this.handlePostNowChanged(true)}
                      style={{
                        marginLeft: "20px",
                      }}
                    ></div>
                    <div
                      className={classnames("check-box", {
                        checked: !postNow,
                      })}
                      onClick={this.handlePostNowChanged(false)}
                      style={{
                        marginLeft: "80px",
                      }}
                    ></div>
                  </div>
                )}
                <div className="date-picker-container">
                  {!postNow && (
                    <React.Fragment>
                      <p className="rununtil-text">Competition start: </p>
                      {!selectedDate && (
                        <DateTimePicker
                          onTimeChange={this.onChangeScheduledDate}
                        />
                      )}
                      {selectedDate && (
                        <React.Fragment>
                          <p className="date-text">
                            {scheduledDate.format("LLL")}
                          </p>
                          <TimePicker onChange={this.onChangeTime} />
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                  <p className="rununtil-text">Run until: </p>
                  <DateTimePicker onTimeChange={this.onChangeRunUntilDate} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="add-competition-footer-container">
                <button
                  type="button"
                  className="btn btn-sm btn-primary add-competition-post-btn"
                  data-dismiss="modal"
                  onClick={this.post}
                  disabled={this.isSaveDisabled()}
                >
                  Post
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-warning"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddCompetition;



// WEBPACK FOOTER //
// ./src/screens/Competitions/components/AddCompetition.js